module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_redefine.js
// module id = 700
// module chunks = 0